<template>
  <div class="xh-esg-index">
    <div class="content">
      <div class="top">
        <div class="toptop"></div>
        <div class="left">
          <img
            src="../../assets/white_theme/esg-rz-pingan.png"
            alt=""
            style="wdith: 180px; height: 180px"
          />
        </div>
        <div class="right">
          <div class="righttop">
            <div class="namebox">
              <div class="name">中国平安保险（集团）股份有限公司</div>
              <div class="code">统一社会信用代码：91440300100012316L</div>
            </div>
            <div class="qrcodebox">
              <img src="../../assets/white_theme/esg-sj-qrcode.png" alt="" />
            </div>
          </div>
          <div class="rightbottom">
            <div class="text">
              <!-- (点击展开)
            <el-button type="danger" icon="el-icon-info" @click="changeDisplay">
              <span v-if="isDisplay == false"
                >展开(点击展开)</span
              >
              <span v-else>隐藏 (点击隐藏)</span> </el-button
            ><br /><br />
            <div
              style="border: 1px solid blue; line-height: 0.8"
              v-if="isDisplay"
            >
            </div> -->
              法人代表：马明哲
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              成立日期：1988-03-21
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              公司官网：www.pingan.cn&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <br />
              主营业务：一般经营项目是：，许可经营项目是：投资保险企业；监督管理控股投资企业的各种国内、国际业务；
              开展保险资金运用业务；经批准开展国内、国际保险业务；经中国保险监督管理委员会及国家有关部门批准的其他业务。（依法须经批准的项目，经相关部门批准后方可开展经营活动）
            </div>
          </div>
        </div>
      </div>

      <div class="bottom">
        <div class="bottombox">
          <div class="bottomtopbox">
            <div class="bottomtopleft">
              <div class="leftline">
                <span class="icon"
                  ><img src="../../assets/white_theme/esg-sj-icon.png" /></span
                ><b style="font-size: 16px; color: var(--font_01);">ESG评分</b>
              </div>
              <div class="rank">
                <div class="rankleft">
                  <div class="first">
                    <div class="rankrank bigfont">{{ this.totalScore }}</div>

                    <div class="rankfont">总评分</div>
                  </div>
                </div>
                <div class="slice">
                  <img src="../../assets/white_theme/esg-rz-slice.png" alt="" />
                </div>
                <div class="rankright">
                  <div class="second">
                    <div class="rankrank secondcolor">
                      {{ this.typeScore.E }}
                    </div>
                    <div class="rankfont">环境评分</div>
                  </div>
                  <div class="third">
                    <div class="rankrank thirdcolor">
                      {{ this.typeScore.S }}
                    </div>

                    <div class="rankfont">社会评分</div>
                  </div>
                  <div class="fourth">
                    <div class="rankrank fourthcolor">
                      {{ this.typeScore.G }}
                    </div>

                    <div class="rankfont">治理评分</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottomtopright">
              <div class="rightline">
                <div class="circle"></div>
                <b class="bbb">企业ESG评价报告</b>
                <div class="pdf">
                  <a
                    href="./dl/pingan.pdf"
                    download="中国平安保险(集团)股份有限公司-2021-09-30-公司ESG评价报告.pdf"
                    target="_self"
                    ><img
                      style="width:128px; height=164px;"
                      src="../../assets/white_theme/esg-rz-pdf.png"
                      alt=""
                  /></a>
                </div>
              </div>
            </div>
          </div>
          <div class="bottombottombox">
            <div class="tboxtitle">
              <div class="ttitle">
                <div class="circle"></div>
                <span class="circlef" style="font-size: 12px">ESG评价</span>
              </div>
              <div class="ttitle">
                <div class="circle"></div>
                <span class="circlef">同行业比较</span>
              </div>
            </div>
            <div class="bottombottomleft">
              <div class="secondchart" style="height: 274px; width: 450px">
                <radarchart :params="radarparams" :url="radarurl"></radarchart>
              </div>
            </div>
            <div class="bottombottomright">
              <div class="thirdchart" style="height: 320px; width: 551px">
                <lineOnechart
                  :params="lineoneparams"
                  :url="lineoneurl"
                ></lineOnechart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import radarchart from "./e4radar.vue";
import lineOnechart from "./e4lineOne.vue";

export default {
  data() {
    return {
      totalScore: "",
      typeScore: {},
      lineoneurl: "",
      lineoneparams: {},
      spread: "300px",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
      ],
      tableHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      loading: false,
      page: {
        currentPage: 1,
        totalPage: 1,
      },
      defaultPageSizeList: [10, 20, 30, 50, 100],
      pageInput: 1,
      sizeForm: {
        keyWord: "",
        infoSource: "",
        title: "",
        type: "0",
        pageNo: 1,
        pageSize: 100,
        beginDate: "",
        endDate: "",
      },
      inputControl: false,
      isDisplay: false,
      radarurl: "",
      radarparams: {},
    };
  },
  mounted() {
    this.radarurl = "/esg/data/company/type_score";
    this.radarparams = {
      type: "E",
      seCode: "601318.SH",
    };
    this.lineoneurl = "/esg/data/score_cp_line_industry";
    this.lineoneparams = {
      type: "A",
      seCode: "601318.SH",
    };
    this.getTypeScore();
    this.getTotalScore();
  },
  methods: {
    ...mapActions("settledInfo/index", {
      getTableData: "GET_TABLE_DATA",
      type_score: "type_score",
      total_score: "total_score",
    }),
    getTypeScore() {
      var _this = this;
      let params = {
        seCode: "601318.SH",
      };

      this.type_score(params).then((res) => {
        _this.typeScore = res;
      });
    },

    getTotalScore() {
      var _this = this;
      let params = {
        seCode: "601318.SH",
      };

      this.total_score(params).then((res) => {
        _this.totalScore = res;
      });
    },
  },
  computed: {
    maxTableHeight() {
      return this.tableHeight - 190;
    },
  },
  components: {
    radarchart,
    lineOnechart,
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 1100px;
  margin: 0 auto;
}
.top {
  background: var(--comp_08);
  margin-top: 40px;
  min-height: 240px;
}
.toptop {
  height: 30px;
}
.left {
  height: 182px;
  width: 182px;
  margin-left: 28px;
  float: left;
}
.right {
  width: 839px;
  margin-left: 30px;
}
.namebox {
  height: 62px;
  width: 450px;
  float: left;
}
.name {
  width: 448px;
  height: 33px;
  color: var(--font_01);
  font-size: 24px;
  font-weight: 500;
}
.code {
  width: 380px;
  height: 22px;
  margin-left: 6px;
  margin-top: 6px;
  font-size: 16px;
  font-weight: 400;
  color: var(--font_01);
}
.righttop {
  height: 88px;
  width: 100%;
  margin-left: 207px;
}
.qrcodebox {
  float: right;
  position: relative;

  img {
    position: absolute;
    top: -14px;
    right: 3px;
    width: 90px;
    height: 90px;
  }
}
.rightbottom {
  width: 837px;
  background: #f5faff;
  margin-left: 206px;
  line-height: 25px;
}
.bottom {
  margin-top: 10px;
  height: 637px;
  background: var(--comp_08);
  padding-top: 50px;
}
.bottombox {
  width: 1000px;
  height: 500px;
  margin-left: 50px;
}
.icon {
  margin-right: 13px;
}
.circle {
  float: left;
  z-index: 79;
  width: 10px;
  height: 10px;
  background-color: rgba(122, 213, 244, 1);
  border-radius: 50%;
  margin-right: 6px;
  margin-top: 5px;
}
.bottomtopbox {
  height: 197px;
  width: 970px;
}
.bottomtopleft {
  width: 771px;
  height: 167px;
  float: left;
}
.bottomtopright {
  height: 193px;
  width: 140px;
  float: right;
}
.bbb {
  font-size: 14px;
  color: var(--font_01);
}
.rank {
  margin-top: 35px;
  background: var(--xhcj-card-intro);
  height: 110px;
}
.first {
  width: 206px;
  height: 110px;
  float: left;
}
.rankright {
  display: flex;
}
.second,
.third,
.fourth {
  flex: 1;
  text-align: center;
}
.bottombottombox {
  width: 913px;
  height: 300px;
  margin-left: 5px;
  margin-top: 26px;
}
.bottombottomleft {
  height: 274px;
  width: 312px;
  float: left;
}
.bottombottomright {
  height: 274px;
  width: 551px;
  float: left;
  margin-left: 50px;
  margin-top: -15px;
}
.rankrank {
  font-size: 36px;
  text-align: center;
  line-height: 46px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: 700;
}

.rankfont {
  font-size: 10px;
  color: var(--xhcj-sj-dc1f);
  text-align: center;
}
.secondcolor {
  color: #90cc75;
}
.thirdcolor {
  color: #5470c6;
}
.fourthcolor {
  color: #f47373;
}
.bigfont {
  font-size: 48px;
  color: var(--font_01);
}
.slice {
  position: relative;
  img {
    position: absolute;
    top: 20px;
  }
}
.thirdchart {
  margin-left: 105px;
}
.tboxtitle {
  display: flex;
  height: 30px;
  margin-top: 20px;
}
.ttitle {
  flex: 1;
}
.circlef {
  // margin-left: 10px;
  font-size: 12px;
  color: var(--font_01);
}
.pdf {
  margin-top: 10px;
}
.text {
  padding: 10px 20px 10px 20px;
  font-size: 12px;
  background: var(--xhcj-card-intro);
  color: var(--font_01);
}
</style>
